export default "__VITE_ASSET__b34bf428__"